module.exports = __webpack_public_path__ + "img/align_center.4f780fd7.svg";